/**
 * Dorahi hero slider.
 * The React source (components/homepage/HeroSlider.tsx) renders a single
 * static image, so this only activates when the section has 2+ slide blocks:
 * a simple timed cross-fade using the opacity utilities already on each slide.
 */
(() => {
  class DorahiHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;

      if (this.slides.length < 2 || this.dataset.autoplay !== 'true') return;

      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.start();

      // Don't burn cycles (or desync) while the tab is hidden.
      this.onVisibility = () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.start();
        }
      };
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) {
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const prev = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const current = this.slides[this.index];

      prev.classList.remove('opacity-100');
      prev.classList.add('opacity-0', 'pointer-events-none');
      prev.setAttribute('aria-hidden', 'true');

      current.classList.remove('opacity-0', 'pointer-events-none');
      current.classList.add('opacity-100');
      current.removeAttribute('aria-hidden');
    }
  }

  if (!customElements.get('dorahi-hero-slider')) {
    customElements.define('dorahi-hero-slider', DorahiHeroSlider);
  }
})();
